import { TeamBillingUIState, TeamBillingUIAction } from './types'

export const initialUIState: TeamBillingUIState = {
  sendInvoiceModalOpen: false,
  sendInvoiceBilling: null,
  pdfLoadingIds: [],
}

export function uiReducer(
  state: TeamBillingUIState,
  action: TeamBillingUIAction
): TeamBillingUIState {
  switch (action.type) {
    case 'OPEN_SEND_INVOICE_MODAL':
      return {
        ...state,
        sendInvoiceModalOpen: true,
        sendInvoiceBilling: action.payload,
      }
    case 'CLOSE_SEND_INVOICE_MODAL':
      return {
        ...state,
        sendInvoiceModalOpen: false,
        sendInvoiceBilling: null,
      }
    case 'ADD_PDF_LOADING':
      return {
        ...state,
        pdfLoadingIds: [...state.pdfLoadingIds, action.payload],
      }
    case 'REMOVE_PDF_LOADING':
      return {
        ...state,
        pdfLoadingIds: state.pdfLoadingIds.filter(
          (id) => id !== action.payload
        ),
      }
    default:
      return state
  }
}
